export const Validations =
// export const ValidationPatterns =
{
    emailPattern: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,

    passwordPattern: '(?=.*[A-Za-z])(?=.*[0-9])(?=.*[$@$!#^~%*?&,.<>"\'\\;:\{\\\}\\\[\\\]\\\|\\\+\\\-\\\=\\\_\\\)\\\(\\\)\\\`\\\/\\\\\\]])[A-Za-z0-9\d$@].{7,}',

    number_pattern: "^[1-9][0-9]*$",

    space_pattern: /^[^\s]+(\s+[^\s]+)*$/,

    name_pattern: /^[a-zA-z ]+$/
}